import * as Api from '@ViewModels';
import { MessageBubble } from '../MessageBubble';

interface IProps {
	entity?: Api.IEntity | Api.TimelineEventViewModel<Api.ITimelineEvent>;
	messages?: Api.ITextMessage[];
}

export const getRenderableEventMessages = (messages?: Api.ITextMessage[]) =>
	(messages ?? []).filter(
		(message, i, all) =>
			(!message.id || all.findIndex(x => x.id === message.id) === i) && !!(message.media?.length || message.text)
	);

export const ConversationEventMessages = ({ entity, messages }: IProps) => (
	<>
		{getRenderableEventMessages(messages).flatMap((message, i) => {
			const messageKey = message.id ?? `message-${i}`;
			const bubbles: JSX.Element[] = [];

			message.media?.forEach((media, mediaIndex) => {
				bubbles.push(
					<MessageBubble
						entity={entity}
						id={`${messageKey}-media-${mediaIndex}`}
						key={`${messageKey}-media-${mediaIndex}`}
						mediaContent={media}
						showAvatar={true}
						showTimeStamp={true}
						textMessage={message}
					/>
				);
			});

			if (message.text) {
				bubbles.push(
					<MessageBubble
						entity={entity}
						id={messageKey}
						key={messageKey}
						showAvatar={true}
						showTimeStamp={true}
						textMessage={message}
					/>
				);
			}

			return bubbles;
		})}
	</>
);
